import Utils from '@/utils/utils';
/**
 * 链接map
 */
const pricingUrlMap = {
  ar: 'https://ar.hitpaw.com/pricing.html',
  br: 'https://online.hitpaw.com.br/pricing.html',
  cn: 'https://online.hitpaw.com/pricing.html',
  de: 'https://online.hitpaw.de/pricing.html',
  es: 'https://online.hitpaw.es/pricing.html',
  en: 'https://online.hitpaw.com/pricing.html',
  fr: 'https://online.hitpaw.fr/pricing.html',
  id: 'https://online.hitpaw.id/pricing.html',
  inn: 'https://online.hitpaw.in/pricing.html',
  it: 'https://online.hitpaw.it/pricing.html',
  jp: 'https://online.hitpaw.jp/pricing.html',
  kr: 'https://online.hitpaw.kr/pricing.html',
  nl: 'https://online.hitpaw.nl/pricing.html',
  ru: 'https://online.hitpaw.ru/pricing.html',
  tr: 'https://tr.hitpaw.com/pricing.html',
  tw: 'https://online.hitpaw.com/pricing.html',
};

let lang = Utils.getLanguage();
lang = lang === 'in' ? 'inn' : lang;

export default pricingUrlMap[lang];
